const authConfig = {
  domain: process.env.VUE_APP_AUTH_DOMAIN,
  clientId: process.env.VUE_APP_AUTH_CLIENT_ID,
  audience: process.env.VUE_APP_AUTH_AUDIENCE
};

export default authConfig;
